import React, { useContext, useEffect, useState } from 'react';
import { Alert, Row, Col, Container } from 'react-bootstrap';
import { Loading, PageHeader, Breadcrumbs, PageTitle } from 'modules';
import { useQuery } from '@apollo/react-hooks';
import { AgreementByContractQuery } from 'queries/Agreement/AgreementData';
import GoBackButton from 'components/GoBackButton';
import AgreementInput from 'components/AgreementInput';
import ButtonSubmitAgreement from 'components/ButtonSubmitAgreement';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import { FormScene } from 'constants/FormScene';
import { useSelector } from 'react-redux';
import {
  selectClientAccess,
  selectConsultantAccess,
  selectMeetingModeOffline,
  selectOnlineFormContract,
} from 'stores/onlineForm/onlineForm';
import { Trans, useTranslation } from 'react-i18next';

const OnlineFormAgreement = () => {
  const { t } = useTranslation();
  const wsContext = useContext(WebsocketContext);

  const contract = useSelector(selectOnlineFormContract);
  const isConsultantAccess = useSelector(selectConsultantAccess);
  const isClientAccess = useSelector(selectClientAccess);
  const isOfflineMode = useSelector(selectMeetingModeOffline);

  const [agreementChecked, setAgreementChecked] = useState(false);

  const agreementQuery = useQuery(AgreementByContractQuery, {
    variables: {
      where: {
        contractId: contract?.id,
      },
    },
    fetchPolicy: 'network-only',
  });

  const handleChange = (e: React.ChangeEvent) => {
    setAgreementChecked((e.target as any).value);
    wsContext?.send({
      action: WebsocketActions.CLIENT_AGREEMENT_CHECKED,
      value: (e.target as any).value,
    });
  };

  const handleSubmitAgreement = () => {
    wsContext.send({
      action: WebsocketActions.STEP_CHANGE,
      value: FormScene.Detail,
    });
  };

  useEffect(() => {
    wsContext?.ws?.on(WebsocketActions.CLIENT_AGREEMENT_CHECKED, (data) => {
      setAgreementChecked(!!data);
    });
    return () => {
      wsContext?.ws?.off(WebsocketActions.CLIENT_AGREEMENT_CHECKED);
    };
    // eslint-disable-next-line
  }, []);

  if (agreementQuery.loading) {
    return <Loading />;
  }

  return (
    <>
      <PageHeader>
        <Breadcrumbs>
          <Breadcrumbs.Item to="/" active={false}>
            <Trans>ONLINE_FORMS.AGREEMENT</Trans>
          </Breadcrumbs.Item>
        </Breadcrumbs>
      </PageHeader>
      <Container className="m-0">
        <PageTitle title={t('ONLINE_FORMS.AGREEMENT')} />

        {isConsultantAccess && !isOfflineMode && (
          <Alert variant="danger" className="mb-4">
            Čaká sa na udelenie súhlasu so spracovaním osobných údajov klientom ...
          </Alert>
        )}
        {(isClientAccess || isOfflineMode) && (
          <>
            <div className="mb-3">
              <strong>Popíšte mi teraz Vašu životnú situáciu, v ktorej sa nachádzate.</strong>
            </div>
            <div className="mb-3">
              Pre pokračovanie je potrebné, aby ste nám udelili súhlas so spracovaním osobných údajov. Bez tohto súhlasu
              nemôžeme pokračovať.
            </div>
            <AgreementInput
              name="agreement"
              disabled={isConsultantAccess && !isOfflineMode}
              checked={agreementChecked}
              onChange={handleChange}
            />
          </>
        )}
        <Row>
          <Col className="mt-3">
            {(isConsultantAccess || isOfflineMode) && <GoBackButton step={FormScene.Starter} />}
            {(isClientAccess || isOfflineMode) && contract && (
              <ButtonSubmitAgreement
                // TODO: typ souhlasu do proměnných !!!
                typ="marketing"
                source={`Online formulář ${window.location.href}`}
                data={{
                  contractId: contract.id,
                  clientId: contract.id_klient,
                  lastName: contract.prijmeni,
                  firstName: contract.jmeno,
                  email: contract.email || '',
                  mobil: contract.mobil || '',
                  city: contract.mesto || '',
                  zipCode: contract.psc || '',
                }}
                disabled={!agreementChecked}
                onSubmit={handleSubmitAgreement}
              />
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default OnlineFormAgreement;
